module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm3_m.bc2ff1b4ee03b41125a4b7d57fc9257e.png";